<!-- eslint-disable vue/require-explicit-emits -->
<template>
  <span v-if="false" />
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";

export default {
  name: "InvalidElement",
  mixins: [DynamicElementMixin],
  elementPanelSettings: {
    displayName: "Invalid Element",
    displayIcon: "button",
    elementGroup: "general",
    elementType: "element",
  },
  deprecated: true,
};
</script>
